export var bodyFontThemes = {sourceSans:'c5-27-4_odhvdm1',notoSerif:'c5-27-4_odhvdm2',lato:'c5-27-4_odhvdm3',montserrat:'c5-27-4_odhvdm4',openSans:'c5-27-4_odhvdm5',raleway:'c5-27-4_odhvdm6'};
export var bodyFontVars = {fontFamily:'var(--c5-27-4_odhvdm0)'};
export var defaultBodyFontFamily = 'Inter';